import React, { useState, useEffect } from "react"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  Table,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap"
import ReactApexChart from "react-apexcharts"
import Breadcrumbs from "components/Common/Breadcrumb"
import { dashboardReport, getOrgMembers } from "helpers/api_helper"

const Dashboard = () => {
  const [dashboardData, setDashboardData] = useState({
    certificates: 0,
    totalCertificates: 0,
    pending: 0,
    rejected: 0,
    activePrograms: 15,
    totalPayments: 35000000,
    totalSigners: 0,
    pendingPayments: 15000,
    totalEmployees: 180,
    totalStudents: 4500,
  })

  const [signers, setSigners] = useState([])

  const [currentPage, setCurrentPage] = useState(1)
  const pageSize = 5

  useEffect(() => {
    fetchDashboardReport()
    fetchSigners()
  }, [])

  const fetchDashboardReport = async () => {
    try {
      const response = await dashboardReport()
      if (response?.data) {
        const d = response.data.count
        setDashboardData({
          ...dashboardData,
          totalCertificates: d.documentCount,
          certificates: d.validDocumentCount,
          pending: d.pendingDocumentCount,
          rejected: d.revokeDocumentCount,
          totalSigners: d.signerCount,
        })
      }
    } catch (error) {
      console.error(`dashboard error: ${error}`)
    }
  }

  const fetchSigners = async () => {
    try {
      const response = await getOrgMembers()
      if (response?.list) {
        const formattedData = response.list.filter(s => s.role === 'signer').map((s) => ({
          id: s.id,
          name: s.name,
          email: s.email,
          role: s.roleName,
        }))
        setSigners(formattedData)
      }
    } catch (error) {
      console.error(`fetch signers error: ${error}`)
    }
  }

  const StatsCard = ({ title, value, icon, color }) => (
    <Card>
      <CardBody>
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <p className="text-muted mb-2">{title}</p>
            <h4 className="mb-0">{value}</h4>
          </div>
          <div className={`avatar-sm rounded-circle bg-${color} align-self-center mini-stat-icon`}>
            <span className="avatar-title rounded-circle bg-primary">
              <i className={`bx ${icon} font-size-24`}></i>
            </span>
          </div>
        </div>
      </CardBody>
    </Card>
  )

  const financialChartOptions = {
    chart: {
      height: 350,
      type: "area",
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth", width: 2 },
    colors: ["#556ee6", "#f1b44c"],
    xaxis: {
      categories: ["1 сар", "2 сар", "3 сар", "4 сар", "5 сар", "6 сар", "7 сар", "8 сар", "9 сар"],
    },
    grid: { borderColor: "#f1f1f1" },
  }

  const financialChartSeries = [
    {
      name: "Диплом",
      data: [45, 52, 38, 45, 19, 23, 25, 35, 40],
    },
    {
      name: "Сертификат",
      data: [35, 41, 62, 42, 13, 18, 29, 37, 36],
    },
  ]

  const programChartOptions = {
    chart: { type: "donut" },
    colors: ["#34c38f", "#556ee6", "#f46a6a", "#50a5f1", "#f1b44c"],
    legend: { position: "bottom" },
    labels: ["Бакалавр", "Магистр", "Доктор", "Богино хөтөлбөр", "Бусад"],
  }

  const programChartSeries = [44, 55, 41, 17, 15]

  const diplomaStatusOptions = {
    chart: {
      type: "bar",
      height: 350,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
      },
    },
    colors: ["#34c38f", "#556ee6"],
    xaxis: {
      categories: ["Баталгаажсан", "Хянагдаж буй", "Хүчингүй"],
    },
  }

  const diplomaStatusSeries = [
    {
      name: "Сертификат",
      data: [dashboardData.certificates, dashboardData.pending, dashboardData.rejected],
    },
    // {
    //   name: "Диплом",
    //   data: [0, 0, 0],
    // }
  ]

  const handlePageChange = (page) => {
    setCurrentPage(page)
  }

  const paginatedSigners = signers.slice((currentPage - 1) * pageSize, currentPage * pageSize)

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Хяналтын самбар" breadcrumbItem="Статистик" />

          <Row>
            <Col xl={3} md={6}>
              <StatsCard
                title="Нийт гэрчилгээ"
                value={dashboardData.totalCertificates}
                icon="bx-copy-alt"
                color="primary"
              />
            </Col>
            <Col xl={3} md={6}>
              <StatsCard
                title="Хянагдаж буй"
                value={dashboardData.pending}
                icon="bx-dna"
                color="success"
              />
            </Col>
            <Col xl={3} md={6}>
              <StatsCard
                title="Хүчингүй"
                value={dashboardData.rejected}
                icon="bx-block"
                color="info"
              />
            </Col>
            <Col xl={3} md={6}>
              <StatsCard
                title="Гарын үсэг зурагчид"
                value={dashboardData.totalSigners}
                icon="bx-pen"
                color="warning"
              />
            </Col>
          </Row>

          {/* <Row>
            <Col xl={8}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">График</CardTitle>
                  <ReactApexChart
                    options={financialChartOptions}
                    series={financialChartSeries}
                    type="area"
                    height={350}
                  />
                </CardBody>
              </Card>
            </Col>
            <Col xl={4}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Төлбөрийн статус</CardTitle>
                  <div className="text-center">
                    <div className="mb-4">
                      <i className="bx bx-dollar-circle text-primary display-4" />
                    </div>
                    <h3>₮{dashboardData.totalPayments.toLocaleString()}</h3>
                    <p>Нийт төлбөр</p>
                    <p>Одоогийн төлөвлөгөө: <span className="text-success">Багц 3 (10,000 кредит)</span></p>
                    <p className="text-muted">
                      <span className="text-danger me-2">
                        ₮{dashboardData.pendingPayments.toLocaleString()}
                      </span>
                      1ш кредитийн үнэ
                    </p>
                    <a href="https://diplom.mn/pricing/" target="_blank" rel="noopener noreferrer" className="text-primary">Багц харах</a>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row> */}

          <Row>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Гарын үсэг зурагчдын жагсаалт</CardTitle>
                  <Table className="table mb-0">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Нэр</th>
                        <th>Имэйл</th>
                        <th>Үүрэг</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedSigners.map((signer, index) => (
                        <tr key={signer.id}>
                          <th scope="row">{(currentPage - 1) * pageSize + index + 1}</th>
                          <td>{signer.name}</td>
                          <td>{signer.email}</td>
                          <td>{signer.role}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {pageSize < signers.length ? (
                    <Pagination className="pagination justify-content-end mt-3">
                      <PaginationItem disabled={currentPage <= 1}>
                        <PaginationLink
                          onClick={() => handlePageChange(currentPage - 1)}
                          previous
                        />
                      </PaginationItem>
                      {Array.from({ length: Math.ceil(signers.length / pageSize) }).map((_, index) => (
                        <PaginationItem active={index + 1 === currentPage} key={index}>
                          <PaginationLink onClick={() => handlePageChange(index + 1)}>
                            {index + 1}
                          </PaginationLink>
                        </PaginationItem>
                      ))}
                      <PaginationItem disabled={currentPage >= Math.ceil(signers.length / pageSize)}>
                        <PaginationLink
                          onClick={() => handlePageChange(currentPage + 1)}
                          next
                        />
                      </PaginationItem>
                    </Pagination>
                  ) : <></>}
                </CardBody>
              </Card>
            </Col>
            <Col xl={6}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">Статистик</CardTitle>
                  <ReactApexChart
                    options={diplomaStatusOptions}
                    series={diplomaStatusSeries}
                    type="bar"
                    height={300}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>

          {/* <Row>
            <Col xl={12}>
              <FutureProjections />
            </Col>
          </Row> */}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Dashboard